export default __webpack_public_path__ + "static/media/GTWalsheimPro-Bold.6ead5fc9.woff";